/**
 * 描述：处理编辑页中栏目路径的显示区分问题
 * 作者：Bai.Zhiming
 * 日期：2017-10-16
 */
angular.module("editPageChannelHandle", []).
directive("channelPath", ["$timeout", function($timeout) {
    return {
        restrict: "A",
        replace: false,
        scope: false,
        link: function(scope, $elem, $attrs) {
            scope.$watch("CHANNEL", function(newV) {
                if (newV) {
                    $timeout(function() {
                        init();
                    });
                }
            });
            /**
             * [init description] 初始化
             * @return {[type]} [description]
             */
            function init() {
                var array = $elem.html().split("&gt;");
                var html = [];
                for (var i = 0; i < array.length; i++) {
                    if (i === 0) {
                        html.push("<span class='site'>" + array[i] + "</span>");
                    } else {
                        if (i === array.length - 1) {
                            html.push("<span class='channel_last'>" + array[i] + "</span>");
                        }else{
                            html.push("<span class='channel'>" + array[i] + "</span>");
                        }
                    }
                }
                html = html.join(">");
                $elem.html(html);
            }
        }
    };
}]);